import CustomCategoryWeightRange from "../../../model/packageDelivery/customCategory/CustomCategoryWeightRange";
import {Config} from "../../../util/Config";
import {RestClient} from "../../../util/RestClient";
import Response from "../../../model/Response";
import Request from "../../../model/Request";
import { PackageDeliveryType } from "../../../model/packageDelivery/PackageDeliveryType";


export module CustomCategoryWeightRangeService{

    export async function getAll(agencyId: string | null = null): Promise<Response<CustomCategoryWeightRange[]>> {
        const url = Config.get("GET_WEIGHT_RANGES_URL", {agencyId})
        const request = new Request(url)
        const response = await RestClient.get(request)
        if(response.success){
            const resultData = response.data;
            if(resultData){
                const data = resultData.map((t:any)=> new CustomCategoryWeightRange(
                    t.id,
                    t.customCategoryId,
                    t.agencyId,
                    t.from,
                    t.to,
                    t.price,
                    t.deliveryType
                ))
                return new Response<CustomCategoryWeightRange[]>(true, data, response.error)
            }
        }
        return new Response<CustomCategoryWeightRange[]>(false, [], response.error, response.status)
    }

    export async function get(customCategoryId: string): Promise<Response<CustomCategoryWeightRange[]>> {
        const url = Config.get("GET_CUSTOM_CATEGORY_WEIGHT_RANGE_URL", { customCategoryId })
        const request = new Request(url)
        const response = await RestClient.get(request)
        if(response.success){
            const resultData = response.data;
            if(resultData){
                const data = resultData.map((t:any)=> new CustomCategoryWeightRange(
                    t.id,
                    t.customCategoryId,
                    t.agencyId,
                    t.from,
                    t.to,
                    t.price,
                    t.deliveryType
                ))
                return new Response<CustomCategoryWeightRange[]>(true, data, response.error)
            }
        }
        return new Response<CustomCategoryWeightRange[]>(false, [], response.error, response.status)
    }

    export async function find(weightRangeId:string, customCategoryId:string): Promise<Response<CustomCategoryWeightRange>> {
        const url = Config.get("FIND_CUSTOM_CATEGORY_WEIGHT_RANGE_URL", {
            customCategoryId: customCategoryId,
            weightRangeId:weightRangeId
        });
        const request = new Request(url);
        const response = await RestClient.get(request);
        if (response.success) {
            const data = response.data;
            if (data) {
                const weightRange = new CustomCategoryWeightRange(
                    data.id,
                    data.customCategoryId,
                    data.agencyId,
                    data.from,
                    data.to,
                    data.price,
                    data.deliveryType
                );
                return new Response<CustomCategoryWeightRange>(true, weightRange, response.error);
            }
        }
        return new Response<CustomCategoryWeightRange>(true, undefined, response.error, response.status);
    }

    export async function getAllFromBaseAgency(): Promise<Response<CustomCategoryWeightRange[]>> {
        const url = Config.get("GET_CUSTOM_CATEGORY_WEIGHT_RANGES_FROM_BASE_AGENCY_URL");
        const request = new Request(url)
        const response = await RestClient.get(request)
        if (response.success) {
            const responseData = response.data;
            if (responseData) {
                const data = responseData.map((t: any) =>
                    new CustomCategoryWeightRange(
                        t.id,
                        t.customCategoryId,
                        t.agencyId,
                        t.from,
                        t.to,
                        t.price,
                        t.deliveryType
                    ));
                return new Response<CustomCategoryWeightRange[]>(true, data, response.error)
            }
        }
        return new Response<CustomCategoryWeightRange[]>(false, undefined, response.error, response.status);
    }

    export async function getPriceFromWeight(
        weight: number,
        customCategoryId: string,
        deliveryType: PackageDeliveryType,
        agencyId?: string
    ): Promise<Response<CustomCategoryWeightRange>>{
        const url = Config.get("GET_PRICE_FROM_CUSTOM_CATEGORY_URL", {
            agencyId,
            customCategoryId,
            weight,
            deliveryType: PackageDeliveryType[deliveryType]
        });
        const request = new Request(url);
        const response = await RestClient.get(request);
        if (response.success) {
            const data = response.data;
            if (data) {
                const weightRange = new CustomCategoryWeightRange(
                    data.id,
                    data.customCategoryId,
                    data.agencyId,
                    data.from,
                    data.to,
                    data.price,
                    data.deliveryType
                );
                return new Response<CustomCategoryWeightRange>(true, weightRange, response.error);
            }
        }
        return new Response<CustomCategoryWeightRange>(false, undefined, response.error, response.status);
    }



    export async function create(data: CustomCategoryWeightRange, customCategoryId: string): Promise<Response<any>> {
        const url = Config.get("CREATE_CUSTOM_CATEGORY_WEIGHT_RANGE_URL", { customCategoryId });
        const request = new Request(url, data);
        return await RestClient.post(request);
    }

    export async function update(data: CustomCategoryWeightRange, customCategoryId: string): Promise<Response<any>>{
        const url = Config.get("UPDATE_CUSTOM_CATEGORY_WEIGHT_RANGE_URL",{ customCategoryId: customCategoryId, weightRangeId: data.id });
        const request = new Request(url, data);
        return await RestClient.put(request);
    }

    export async function remove(weightRangeId: string, customCategoryId: string): Promise<Response<any>>{
        const url = Config.get("REMOVE_CUSTOM_CATEGORY_WEIGHT_RANGE_URL", { customCategoryId: customCategoryId, weightRangeId: weightRangeId });
        const request = new Request(url);
        return await RestClient.remove(request);
    }
}